import React from "react";

import { renderWithBlanks } from "../../../../utils/textUtils";

// 지문 없는 학교 동형 문항(school.passageless, 2026-11-02). 지인에듀가 이런 문항에도 `text` 를 채워 보내는데,
// 그것은 지문이 아니라 영작할 우리말 문장 · 제시 문장 · <보기> 같은 문항의 일부다. 왼쪽 '전체 본문' 칸에
// 띄우면 지문처럼 보여서(장대중1 Lesson 4-6 서술형 1) 발문 아래 상자로 옮긴다.
// 이런 문항의 `paragraph` 는 시험 범위 전체 본문이라 이 문항과 상관이 없다. 그래서 그것도 띄우지 않는다.
export const isPassagelessPage = (page) => Boolean(page?.school?.passageless);

const PassagelessPromptBox = ({ text, isMobile, width = "100%" }) => {
  if (!String(text ?? "").trim()) return null;
  return (
    <div
      style={{
        boxSizing: "border-box",
        width,
        padding: isMobile ? "12px 14px" : "14px 20px",
        border: "1px solid #E6EDEC",
        borderRadius: "12px",
        backgroundColor: "#FAFCFC",
        fontSize: isMobile ? "15px" : "17px",
        lineHeight: 1.8,
        textAlign: "left",
        wordBreak: "keep-all",
      }}
    >
      {String(text)
        .split("\n")
        .map((line, index) => (
          <div key={index}>{line.trim() ? renderWithBlanks(line) : <br />}</div>
        ))}
    </div>
  );
};

export default PassagelessPromptBox;
